import { Component, OnInit, ViewChild } from '@angular/core';

import { Client } from '../../shared/client.model';

import {
  AlertController,
  IonRouterOutlet,
  LoadingController,
  ModalController,
  NavController,
  ToastController
} from '@ionic/angular';
import { Product } from '../../shared/product.model';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { OrderResponse } from '../../shared/orderResponse.model';
import { OrderDetailResponse } from '../../shared/orderDetailResponse.model';
import { Order } from '../../shared/order.model';
import { BnplService } from 'src/app/service/bnpl.service';
import { Fua } from 'src/app/shared/fua.model';
import { DetailBnpl } from 'src/app/shared/detailBnpl.model';
import { Constant } from '../../shared/model/Constant';
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-terms',
  templateUrl: './terms.page.html',
  styleUrls: ['./terms.page.scss'],
})
export class TermsPageBnpl implements OnInit {

  detailBnpl: DetailBnpl;
  balance: number = 0;

  orders: Order[];
  ordersFiltered: Order[];
  client: Client;
  product: Product;
  order: OrderResponse;
  orderDetails: OrderDetailResponse[];
  orderId: string;
  totalAmountProduct: number;
  descount: string;
  showConfirm: boolean;
  showAccounts: boolean;
  showModalBnplInfo: boolean = false;
  title: string = "!UPS¡";
  message: string;
  bnplTransactionId: string;
  ipClient: string;
  pdfSrc: string;


  constructor(public modalController: ModalController,
    public alertController: AlertController,
    public toastController: ToastController,
    private nav: NavController,
    private authService: AuthService,

    private bnplService: BnplService,
    public loadingController: LoadingController, private router: Router) {

    this.detailBnpl = JSON.parse(localStorage.getItem(Constant.detailBnpl));
    console.log("Terms: ");
    console.log(this.detailBnpl);
    localStorage.removeItem(Constant.detailBnpl);
    this.pdfSrc = environment.web.pdfTyCUri + "reglamento-prestamo-bnpl.pdf";
    if (this.detailBnpl) {
      this.balance = this.detailBnpl.balance;
      var requestRetrieveTerms = {
        "bnplTransactionId": this.detailBnpl.bnplTransactionId,
        "idOrden": this.detailBnpl.order.idOrder,
        "ip": this.ipClient,
        "idClient": this.detailBnpl.order.idUser
      };
      this.bnplService.sendTrxTyC(requestRetrieveTerms).subscribe((res: Fua) => {
        console.log(res);
      }, error => {
        console.warn('Error actualizando TyC  ', error);
        //this.presentToast('No se encuentra el proveedor disponible para la actualizacion de los TyC.');
      });
    }
  }

  sendFuaBnpl() {
    if (this.detailBnpl) {
      this.detailBnpl.order.typeFua = Constant.typeFuaCD;
      console.log(this.detailBnpl);
      localStorage.setItem(Constant.detailBnpl, JSON.stringify(this.detailBnpl));
      var requestFua = {
        "authenticationMode": Constant.typeFuaCD,
        "idOrden": this.detailBnpl.order.idOrder,
        "ip": this.ipClient,
        "idClient": this.detailBnpl.order.idUser

      };
      this.bnplService.sendTrxFuaBnpl(requestFua).subscribe((res: Fua) => {
        console.log(res.url);
        window.location.href = res.url;
      }, error => {
        console.warn('Error fua autenticacion ', error);
        this.presentToast('No se encuentra el proveedor disponible.');
      });
    }else{
      this.presentToast('No se encuentra el proveedor disponible para proceso de firma.');
    }

  }



  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 1000,
      position: 'top',
      mode: 'ios',
      color: 'primary'
    });
    toast.present();
  }

  ngOnInit() {
    this.bnplService.getIp().subscribe((res: any) => {
      console.log(res);
      this.ipClient = res.IPv4;
    }, error => {
      console.warn('Error fua no ip 1', error);
      this.bnplService.getIp1().subscribe((res: any) => {
        console.log(res);
        this.ipClient = res.ip;
      }, error => {
        console.warn('Error fua no ip 2', error);
      });
    });
  }



  // sendTyC() {
  //   var requestRetrieveTerms = {
  //     "data": {
  //       "bnplTransactionId": this.detailBnpl.bnplTransactionId,
  //       "terms": {
  //         "type": Constant.typeTyC
  //       }
  //     }
  //   };
  //   this.bnplService.sendTyC(requestRetrieveTerms).subscribe((res: Fua) => {
  //     console.log(res);

  //     //   window.location.href = 'https://autenticacion.apps.bancolombia.com/login/oauth/authorize/?response_type=code&client_id=PVD&redirect_uri=https://bnpl-bancolombia.payvalida.com/onboarding/notification';
  //   }, error => {
  //     console.warn('Error fua autenticacion ', error);
  //     this.presentToast('No se encuentra el proveedor disponible.');
  //   });
  // }

  close() {
    this.showConfirm = false;
    this.showAccounts = false;
  }


  onWillDismissConfirm(modalEvent: Event) {
    if (modalEvent.type === 'willDismiss') {
      this.showConfirm = false;
    }
  }

  onWillDismissMethod(modalEvent: Event) {
    if (modalEvent.type === 'willDismiss') {
      this.showAccounts = false;
    }
  }



  //https://bnpl-yp-dev.trantec-dev.com/authSession
  //https://bnpl-yp-dev.trantec-dev.com/authSign


}





